import React, { useState } from "react"
import { injectIntl, FormattedMessage } from "react-intl"
import IntlProps from "../../state/helpers/IntlProps"
import Toggle from "react-toggle"
import Icon from "../../common/icon/icon.component"
import { Button } from "react-bootstrap"

type OwnProps = {
    sendNotification: string
    onChangeCallback: (send: boolean) => void
    configureEmail: () => void
}

const EmailNotificationToggle = (props: OwnProps & IntlProps) => {
    const [sendNotification, setSendNotification] = useState<boolean>(!!props.sendNotification)
    return (
        <>
            <div className="mt-2 d-flex flex-column">
                <div className="d-inline-flex">
                    <div className="mr-2 custom-form-label">
                        <FormattedMessage id="price_list.send_email_notification" defaultMessage="Send an email notification" />
                    </div>
                    <Toggle
                        id={"price_list-send_notification"}
                        checked={sendNotification}
                        icons={false}
                        onChange={() => {
                            setSendNotification(!sendNotification)
                            props.onChangeCallback(!sendNotification)
                            
                        }}
                    />
                </div>
                {props.sendNotification && (
                    <div className="mt-2">
                        <Button variant="primary" onClick={props.configureEmail}>
                            <Icon value={"envelope"} className={"mr-1"} />
                            <FormattedMessage id="price_list.analytics.configure_email_btn" defaultMessage="Configure email" />
                        </Button>
                    </div>
                )}
            </div>
        </>
    )
}

export default injectIntl(EmailNotificationToggle)



// WEBPACK FOOTER //
// ./src/price-list/components/EmailNotificationToggle.tsx